export const AccountType = {
    transaction: "transaction",
    savings: "savings",
}